// Personal organization is persisted separately from the conversation itself.
export function createChatPreferences(api, state, remember, list) {
  let loaded = false
  async function initialize() {
    if (!loaded) {
      try {
        const { data } = await api.settings()
        state.sort = data.sort
        loaded = true
      } catch (_) {
        state.error = 'Unable to load chat preferences. Try again.'
        return
      }
    }
    await list()
  }
  async function changeSort(sort) {
    if (state.sortBusy || sort === state.sort) return
    const previous = state.sort
    state.sort = sort
    state.sortBusy = true
    state.error = ''
    try {
      await api.saveSettings({ sort })
      await list()
    } catch (_) {
      state.sort = previous
      state.error = 'Unable to save sorting. Try again.'
    } finally {
      state.sortBusy = false
    }
  }
  async function updateChat(chat, changes) {
    if (chat.preferencesBusy || chat.sending) return false
    chat.preferencesBusy = true
    chat.preferencesError = ''
    try {
      if (!chat.saved) {
        const { data } = await api.create({ id: chat.id })
        chat.saved = true
        remember(data)
      }
      const { data } = await api.savePreferences(chat.id, changes)
      remember(data)
      await list()
      return true
    } catch (error) {
      chat.preferencesError = error.response ? error.message : 'Unable to save changes. Try again.'
      return false
    } finally {
      chat.preferencesBusy = false
    }
  }
  return { initialize, changeSort, updateChat }
}
